import { extractYouTubeVideoId } from './youtube';

// Past this far into a song, Previous goes back to its start rather than to the song before
export const RESTART_AFTER_SECONDS = 3;

/** The songs that have a YouTube video, in service order, as the tracks the playlist plays */
export const playlistTracks = (songs) =>
  (songs || [])
    .map((song) => ({ song, videoId: extractYouTubeVideoId(song?.youtube) }))
    .filter(({ videoId }) => videoId)
    .map(({ song, videoId }) => ({ id: song._id, title: song.title, artist: song.artist || '', videoId }));

/** YouTube's own unnamed playlist of these videos, or null for none */
export const watchVideosUrl = (videoIds) =>
  videoIds?.length ? `https://www.youtube.com/watch_videos?video_ids=${videoIds.join(',')}` : null;

/** What Previous does: back to the top of this song, or on to the one before when it has only just begun */
export const previousStep = (index, time) =>
  time > RESTART_AFTER_SECONDS || index === 0 ? { index, restart: true } : { index: index - 1, restart: false };
